import { CookiesProvider } from "react-cookie";

import { GDPRCookieBannerComponent } from "./component";

export const GDPRCookieBanner = () => (
  <CookiesProvider>
    <GDPRCookieBannerComponent />
  </CookiesProvider>
);
